// extracted by mini-css-extract-plugin
export default {"banner":"HeaderWarningBanner-m_banner-K3bobeFg common-m_flexRow-ZPndn63a"};